var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFastMoney = function SvgFastMoney(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 14.5a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.333 7H8.667C7.747 7 7 7.746 7 8.667l-.5 6.666c0 .92.746 1.667 1.667 1.667h11.666c.92 0 1.667-1 1.667-1.667l.5-6.666C22 7.747 21.254 7 20.333 7Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.5 12a1 1 0 0 1 1-1h.008a1 1 0 1 1 0 2H19.5a1 1 0 0 1-1-1ZM8.5 12a1 1 0 0 1 1-1h.007a1 1 0 1 1 0 2H9.5a1 1 0 0 1-1-1Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 8.25a.75.75 0 0 0 0 1.5v-1.5Zm1 3a.75.75 0 0 0 0 1.5v-1.5Zm1 3a.75.75 0 0 0 0 1.5v-1.5Zm2.5-6H2.5v1.5H7v-1.5Zm-.5 3h-3v1.5h3v-1.5Zm0 3h-2v1.5h2v-1.5Z",
    fill: "currentColor"
  })));
};
export default SvgFastMoney;